// @ts-ignore
import Vue from 'vue';

// @ts-ignore
import {Component} from "vue-property-decorator";

//Render File
import WithRender from "Components/Search/search.html";

//Child Components
import PagesSearchCard from "Components/Search/PagesSearchCard/PagesSearchCard";
import ProjectSearchCard from "Components/Search/ProjectSearchCard/ProjectSearchCard";
import ProductSearchCard from "Components/Search/ProductSearchCard/ProductSearchCard";

//API Service
import FilteringService from "Services/filteringService"

//Interfaces
import { ifcSearchResultProductMin } from "Interfaces/ifcSearchResultProductsMin";
import { ifcSearchResultPageMin } from "Interfaces/ifcSearchResultPageMin";
import { ifcSearchResultProjectMin } from "Interfaces/ifcSearchResultProjectMin";

@WithRender
@Component({
  components: {
    ProductSearchCard,
    PagesSearchCard,
    ProjectSearchCard
  }
})

export default class Search extends Vue {
	translations = JSON.parse(document.querySelector('.js-sayt-data').getAttribute('data-translations'));
	responseData: any = null;
	products: ifcSearchResultProductMin[] = [];
	pages: ifcSearchResultPageMin[] = [];
	projects: ifcSearchResultProjectMin[] = [];
	moreProductsLink: string = '';
	moreProjectsLink: string = '';
	morePagesLink: string = '';
	query: string = '';

	$refs!: {
		searchInput: any;
		searchResults: any;
		searchButton: any;
		searchBox: any;
	};

	inputKeyUp(){
		let vm = this;
		vm.query = vm.$refs.searchInput.value;
		vm.morePagesLink = `/search?FilterCriteria.Query=${vm.query}&FilterCriteria.Tab=pages`;
		vm.moreProductsLink = `/search?FilterCriteria.Query=${vm.query}&FilterCriteria.Tab=product`;
		vm.moreProjectsLink = `/search?FilterCriteria.Query=${vm.query}&FilterCriteria.Tab=workbench`;
		vm.showSearchResultsPanel(vm.query);
		vm.getSearchResults(vm.query);
	}

	showSearchResultsPanel(query?) {
		let vm = this;
		let body = document.querySelector('body'); //body is outside of vue so we need to run a query selector on it
		window.removeEventListener('resize', vm.setSearchResultsTopPlacement, false);
		window.removeEventListener('orientationchange', vm.setSearchResultsTopPlacement, false);
		window.addEventListener('resize', vm.setSearchResultsTopPlacement, false);
		window.addEventListener('orientationchange', vm.setSearchResultsTopPlacement, false);


		if(!query) {
			vm.hideSearchResultsPanel();
			return;
		}

		vm.setSearchResultsTopPlacement();
		body.classList.add('state-quick-search-open');
		vm.$refs.searchResults.classList.add('state-visible')
	}

	hideSearchResultsPanel(){
		let vm = this;
		let body = document.querySelector('body'); //body is outside of vue so we need to run a query selector on it

		body.classList.remove('state-quick-search-open');
		vm.$refs.searchResults.classList.remove('state-visible');
		vm.query = '';
		vm.$refs.searchInput.value = '';
	}

	setSearchResultsTopPlacement() {
		let vm = this;
		vm.$refs.searchResults.style.top = vm.getHeaderHeight('.site-header') + 'px'
		vm.$refs.searchResults.style.setProperty('max-height', `calc(100vh - ${vm.getHeaderHeight('.site-header')}px)`);
	}

	getHeaderHeight(el) {
		el = (typeof el === 'string') ? document.querySelector(el) : el;
		let styles = window.getComputedStyle(el);
		let margin = parseFloat(styles['marginTop']);

		if(window.innerWidth < 768) {
			return Math.ceil((el.offsetHeight + margin) + 85);
		} else {
			return Math.ceil(el.offsetHeight + margin);
		}
	}

	submitSearch() {
		let vm = this;
		if(vm.query) {
			window.location.href = `/search?FilterCriteria.Query=${vm.query}`;
		} else {
			alert('Please Enter a Search Term Before Searching');
		}
	}

	getSearchResults(query: string) {
   	 	let vm = this;
		FilteringService.fetchSearchData(query).then(response => {
			vm.responseData = response.data;
			vm.products = vm.responseData.products;
			vm.pages = vm.responseData.pages;
			vm.projects = vm.responseData.workbench;
		});
  	}
}
